import React from 'react'
import { Image } from '@/atoms/Image'
import { AsH2, AsH3, AsH4, AsH5, CaptionLG, CaptionMD, HeadingLG, ParagraphMD, TitleLG, TitleMD } from '@/atoms/Text'
import { getCloudinaryImageUrl } from '@/utils/Cloudinary'
import { Translate, useTranslate } from '@/utils/translate/translate-client'

type CastMember = {
  name: string
  image: string
  characterName: string
  characterImage: string
  characterBackground: string
  characterBio: string
  characterTitle: string
  knownFor: ActorRole[]
}

type ActorRole = {
  title: string
  character: string
}

const cast: CastMember[] = [
  {
    name: 'Johnny Yong Bosch',
    image: '/v1739288376/angel-studios/projects/gabriel-and-the-guardians/Johnny_Bosch_mjkjbv.webp',
    characterName: 'Gabriel',
    characterImage: '/v1739287567/angel-studios/projects/gabriel-and-the-guardians/gatg_promo_gabriel.webp',
    characterBackground: '/v1739287534/angel-studios/projects/gabriel-and-the-guardians/gabriel_bg.webp',
    characterBio:
      'All the amazing powers and abilities of a Celestial Arch-Prince and Gabriel is stuck as... a gardener? Equipped with his magical scythe, Gabriel will come to understand his powers and responsibility are greater than he ever imagined.',
    characterTitle: "Guardian of Parah'dem",
    knownFor: [
      {
        title: 'Bleach',
        character: 'Ichigo Kurosaki',
      },
      {
        title: "Mighty Morphin' Power Rangers",
        character: 'Black Ranger',
      },
      {
        title: 'Dragon Ball: Sparking! Zero',
        character: 'Broly',
      },
      {
        title: 'Akira',
        character: 'Kaneda',
      },
    ],
  },
  {
    name: 'Cristina Vee',
    image: '/v1739288375/angel-studios/projects/gabriel-and-the-guardians/Cristina_Valenzuela.webp',
    characterName: 'Namay’ah',
    characterImage: '/v1739287534/angel-studios/projects/gabriel-and-the-guardians/gatg_promo_namayah.webp',
    characterBackground: '/v1739287534/angel-studios/projects/gabriel-and-the-guardians/namayah_bg.webp',
    characterBio:
      'The cunning alchemist and princess of Qayinara. Longing to mend her fractured family, she faces the darkness in search of her lost brother and must make a crucial choice: embrace the shadow of her royal lineage or surrender herself to the hope of truth.',
    characterTitle: 'Alchemist & Princess',
    knownFor: [
      {
        title: 'Miraculous: Tales of Ladybug & Cat Noir',
        character: 'Ladybug',
      },
      {
        title: 'Hunter x Hunter',
        character: 'Killua Zoldyck',
      },
      {
        title: 'Sailor Moon',
        character: 'Sailor Mars',
      },
      {
        title: 'Helluva Boss',
        character: 'Verosika Mayday',
      },
    ],
  },
  {
    name: 'Matt Lanter',
    image: '/v1739288375/angel-studios/projects/gabriel-and-the-guardians/Matt_Lanter_ayajdx.webp',
    characterName: 'Nok',
    characterImage: '/v1739287534/angel-studios/projects/gabriel-and-the-guardians/gatg_promo_nok.webp',
    characterBackground: '/v1739287534/angel-studios/projects/gabriel-and-the-guardians/nok_bg.webp',
    characterBio:
      "Though he's a bit of a braggart, Nok is a bold, brave and bright cleric-in-training. Hailing from the Bekorah tribe, Noke feels like he has a lot to prove to himself and to his people.",
    characterTitle: 'Cleric-in-Training',
    knownFor: [
      {
        title: 'Star Wars: The Clone Wars',
        character: 'Anakin Skywalker',
      },
      {
        title: 'Justice League: Throne of Atlantis',
        character: 'Aquaman',
      },
      {
        title: 'Justice League: War',
        character: 'The Flash',
      },
      {
        title: 'Justice League: Crisis on Infinite Earths',
        character: 'Blue Beetle',
      },
    ],
  },
  {
    name: 'James Arnold Taylor',
    image: '/v1739288375/angel-studios/projects/gabriel-and-the-guardians/James_Arnold_Taylor_cavo3q.webp',
    characterName: 'Malachros',
    characterImage: '/v1739287435/angel-studios/projects/gabriel-and-the-guardians/gatg_promo_malachros.webp',
    characterBackground:
      'a_hflip/v1739296596/angel-studios/projects/gabriel-and-the-guardians/BXf7NJZwLe8ODFYF6pyg-malachros_tower_update.webp',
    characterBio:
      'A being wholly consumed by the Dark Chaghta, Malachros now manipulates the land of Ara with his dark powers. Intelligent, calculating and scheming, Malachros uses his skills against our band of heroes.',
    characterTitle: 'Dark Sorcerer of Ara',
    knownFor: [
      {
        title: 'Star Wars: The Clone Wars',
        character: 'Obi-Wan Kenobi',
      },
      {
        title: 'TMNT',
        character: 'Leonardo',
      },
      {
        title: 'Ratchet & Clank',
        character: 'Ratchet',
      },
      {
        title: 'Marvel Rivals',
        character: 'Magneto',
      },
    ],
  },
  {
    name: 'Cristina Milizia',
    image: '/v1739288374/angel-studios/projects/gabriel-and-the-guardians/cristina_Milizia.webp',
    characterName: 'Zion',
    characterImage: '/v1739287421/angel-studios/projects/gabriel-and-the-guardians/zion.webp',
    characterBackground:
      'o_30/v1739296596/angel-studios/projects/gabriel-and-the-guardians/Key_101_S013_018_ParahdemEdgeSeasideA_EXT.webp',
    characterBio:
      "Though still a cub, Zion is destined to be a powerful and important Celestial Cherub. For now though, she's content to race and compete with Gabriel in the gardens of Ara.",
    characterTitle: 'Celestial Cherub Cub',
    knownFor: [
      {
        title: 'DC Super Hero Girls',
        character: 'Poison Ivy',
      },
      {
        title: 'Barbie Doll Adventures',
        character: 'Butterfly Fairy Barbie',
      },
      {
        title: 'League of Legends',
        character: 'Amumu, Annie, Nunu',
      },
      {
        title: 'Jentry Chau vs. The Underworld',
        character: 'Lil, Viv, Stella',
      },
    ],
  },
]

export const GabrielCast: React.FC = () => {
  const { t } = useTranslate('join-the-guild')
  return (
    <section id="cast" className="px-6 py-[104px] lg:px-10">
      <HeadingLG as={AsH2} weight="bold" color="white" className="mb-6 text-center">
        <Translate t={t} i18nKey="meetTheCast">
          Meet the Cast
        </Translate>
      </HeadingLG>

      <div className="mb-6 py-3">
        <CaptionLG weight="semibold" color="white" className="text-center">
          <Translate i18nKey="animatedAndVoicedBy" t={t}>
            Animated by the talent behind <i>Invincible</i>, <i>Castlevania</i>, and <i>X-Men &apos;97</i> and brought
            to life by some of the best voice actors in the industry.
          </Translate>
        </CaptionLG>
      </div>
      {cast.map((member, index) => {
        return (
          <div
            key={member.characterName}
            className={`flex flex-col bg-cover md:flex-row ${
              index % 2 === 1 ? 'md:flex-row-reverse' : ''
            } mb-8 items-center gap-8 rounded-2xl p-8`}
            style={{
              backgroundImage: `url(${getCloudinaryImageUrl({ path: member.characterBackground })})`,
            }}
          >
            <div className="flex-1 space-y-6">
              <div>
                <TitleLG
                  as={AsH3}
                  weight="bold"
                  color="white"
                  className="mb-2 flex items-center justify-center gap-2 md:justify-start"
                >
                  {member.characterName}
                </TitleLG>
                <div className="flex-1 lg:hidden">
                  <Image
                    src={getCloudinaryImageUrl({
                      path: member.characterImage,
                      height: 400,
                      width: 400,
                    })}
                    alt={`${member.characterName} character`}
                    className="mx-auto max-h-[400px] w-full max-w-fit"
                    height={400}
                    width={400}
                    loading="lazy"
                    sizes="(max-width: 1023px) min(400px, 90vw), 0px"
                  />
                </div>
                <ParagraphMD weight="medium" color="core-gray-200" className="text-center lg:text-left">
                  {member.characterBio}
                </ParagraphMD>
                <div className="mt-8 flex flex-col items-center gap-4 sm:flex-row">
                  <Image
                    src={getCloudinaryImageUrl({
                      path: member.image,
                      height: 128,
                    })}
                    alt={member.name}
                    className="h-32 w-32 rounded-full border-4 border-black object-cover"
                    height={128}
                    width={128}
                    loading="lazy"
                    sizes="128px"
                  />
                  <div>
                    <TitleMD
                      as={AsH4}
                      weight="semibold"
                      color="white"
                      className="flex items-center gap-2 font-semibold"
                    >
                      Voiced by {member.name}
                    </TitleMD>
                    <div className="mt-4">
                      <CaptionLG as={AsH5} color="white" weight="semibold" className="mb-2 flex items-center gap-2">
                        Previously Known For:
                      </CaptionLG>
                      <ul className="space-y-1">
                        {member.knownFor.map((role) => {
                          const { character, title } = role

                          return (
                            <li key={title} className="italic">
                              <CaptionMD weight="normal" color="core-gray-200">
                                <Translate t={t} i18nKey="knownAs" values={{ character, title }}>
                                  {{ title }} (as {{ character }})
                                </Translate>
                              </CaptionMD>
                            </li>
                          )
                        })}
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="hidden flex-1 lg:block">
              <Image
                src={getCloudinaryImageUrl({
                  path: member.characterImage,
                  height: 400,
                })}
                alt={`${member.characterName} character`}
                className="mx-auto max-h-[400px] w-full max-w-fit"
                height={400}
                width={400}
                loading="lazy"
                sizes="(min-width: 1024px) min(400px, 33vw), 0px"
              />
            </div>
          </div>
        )
      })}
    </section>
  )
}
